export const themePageCompanyAnaly = {
    title:
        'Select up to five companies to make clusters comparison. Score and other values can be compared among clusters to which the selected companies belong.',
    metric: 'Indicative Data',
    select1: 'Score',
    select2: 'Number of Patent Applications',
    select3: 'Number of Forward Citations (Average)',
    select4: 'Number of Material Patents',
    select5: 'Material Patent rate',
    companyPlaceholder: 'Please type company name to select',
    companyName: 'Select a Company',
    tableColumn1: 'Cluster ID',
    tableColumn2: 'Cluster Name',
    noDataMsg: 'This company does not have this cluster data'
}
